import { useRecordContext } from 'react-admin';
import { JsonField } from 'react-admin-json-view';

import { GetB2bFullyManagedPlanContributionsOneResponse } from '@Common/types/b2b/orders';

import {
  b2bFullyManagedPlanContributionsStatusChoices,
  b2bFullyManagedPlanContributionsTypeChoices,
} from '@sh4res/bo-common/choices/orders';
import { ShowFields, ShowSection, ShowWithNavigation } from '@sh4res/bo-common/components';
import { CurrencyField, IdField, SelectChipField, UTCDateField } from '@sh4res/bo-common/fields';

const FullyManagedPlanContributionsDetails = () => {
  const testId = 'BoExternalFullyManagedPlanContributionsDetails';
  const record = useRecordContext<GetB2bFullyManagedPlanContributionsOneResponse>();

  if (!record) {
    return;
  }

  return (
    <ShowSection label="resources.orders/fully_managed_plan_contributions.sections.title">
      <ShowFields<GetB2bFullyManagedPlanContributionsOneResponse>
        fields={{
          id: (
            <IdField
              reference="orders/fully_managed_plan_contributions"
              data-testid={`${testId}_IdField`}
            />
          ),
          savings_funds_request_id: (
            <IdField
              reference="savings_funds_requests"
              data-testid={`${testId}_SavingsFundsRequestIdField`}
            />
          ),
          matching_contribution_id: (
            <IdField
              reference="orders/fully_managed_plan_contributions"
              data-testid={`${testId}_MatchingContributionIdField`}
            />
          ),
          status: (
            <SelectChipField
              choices={b2bFullyManagedPlanContributionsStatusChoices}
              data-testid={`${testId}_StatusField`}
            />
          ),
          contribution_type: (
            <SelectChipField
              choices={b2bFullyManagedPlanContributionsTypeChoices}
              data-testid={`${testId}_ContributionTypeField`}
            />
          ),
          total_gross_amount: (
            <CurrencyField
              currency="user_currency"
              data-testid={`${testId}_TotalGrossAmountField`}
            />
          ),
          user_currency_amount: (
            <CurrencyField
              currency="user_currency"
              data-testid={`${testId}_UserCurrencyAmountField`}
            />
          ),
          fee_amount: (
            <CurrencyField currency="user_currency" data-testid={`${testId}_FeeAmountField`} />
          ),
          tax_amount: (
            <CurrencyField currency="user_currency" data-testid={`${testId}_TaxAmountField`} />
          ),
          tax_info: <JsonField source="tax_info" data-testid={`${testId}_TaxInfoField`} />,
          paid_at: <UTCDateField data-testid={`${testId}_PaidAtField`} />,
          created_at: <UTCDateField data-testid={`${testId}_CreatedAtField`} />,
          updated_at: <UTCDateField data-testid={`${testId}_UpdatedAtField`} />,
        }}
      />
    </ShowSection>
  );
};

export const FullyManagedPlanContributionsShow = () => (
  <ShowWithNavigation actions={false}>
    <FullyManagedPlanContributionsDetails />
  </ShowWithNavigation>
);
